import {ErrorMessage, Field, Form, Formik} from 'formik'
import {FC, useCallback, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {resetPasswordValid} from '../../../../Utils/_helpers/ValidationSchema'
import {useUpdateSubClientPasswordMutation} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'

export type UpdatePasswordProps = {
  userId: string
  show: boolean
  handleClose: () => void
  callbackFn: () => void
}

const UpdatePassword: FC<UpdatePasswordProps> = (props) => {
  const {userId, show, handleClose, callbackFn} = props
  const [passwordType, setPasswordType] = useState({
    password: true,
    confirm: true,
  })

  const [updatePassword, {isLoading}] = useUpdateSubClientPasswordMutation()

  const handleUpdate = useCallback(
    (param: {password: string; confirmPassword: string}) => {
      updatePassword({
        id: userId,
        password: param.password,
      })
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)

            if (callbackFn) {
              callbackFn()
            }
          } else if ('error' in res) {
            toast.error(res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [userId]
  )

  useEffect(() => {
    setPasswordType({
      password: true,
      confirm: true,
    })
  }, [show])

  return (
    <Modal
      id='kt_modal_update_password'
      tabIndex={1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px'
      className='vh-100'
      show={show}
      onHide={handleClose}
    >
      <div className='modal-header'>
        <h2>Reset Password</h2>
      </div>
      <div className='modal-body p-20 '>
        <Formik
          initialValues={{
            password: '',
            confirmPassword: '',
          }}
          validationSchema={resetPasswordValid}
          onSubmit={(val, {setSubmitting}) => {
            handleUpdate(val)
            setSubmitting(false)
          }}
        >
          {({isSubmitting}) => (
            <Form>
              <div>
                <label htmlFor='password'>Password</label>
                <div className='password-wrap'>
                  <Field
                    className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    type={passwordType.password ? 'password' : 'text'}
                    id='password'
                    name='password'
                  />
                  <span
                    className='svg-icon svg-icon-3'
                    onClick={() => {
                      setPasswordType({...passwordType, password: !passwordType.password})
                    }}
                  >
                    {passwordType.password ? (
                      <i className='bi bi-eye-fill'></i>
                    ) : (
                      <i className='bi bi-eye-slash-fill'></i>
                    )}
                  </span>
                </div>
                <ErrorMessage name='password' component='span' className='text-danger' />
              </div>
              <div className='my-5'>
                <label htmlFor='confirmPassword'>Confirm Password</label>
                <div className='password-wrap'>
                  <Field
                    className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    type={passwordType.confirm ? 'password' : 'text'}
                    id='confirmPassword'
                    name='confirmPassword'
                  />
                  <span
                    className='svg-icon svg-icon-3'
                    onClick={() => {
                      setPasswordType({...passwordType, confirm: !passwordType.confirm})
                    }}
                  >
                    {passwordType.confirm ? (
                      <i className='bi bi-eye-fill'></i>
                    ) : (
                      <i className='bi bi-eye-slash-fill'></i>
                    )}
                  </span>
                </div>
                <ErrorMessage name='confirmPassword' component='span' className='text-danger' />
              </div>
              <button className='btn btn-primary'>
                {isLoading || isSubmitting ? 'Loading....' : 'Reset Password'}{' '}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export default UpdatePassword
